import DatePicker from "react-datepicker"

import { getDateFNSLocale } from "utils/getDateFNSLocale"

import { ISelectDateProps } from "./SelectDateTypes"

import { FormControl, Box } from "@chakra-ui/react"
import FormLabel from "components/UI/atoms/FormLabel"
import Icon from "components/UI/atoms/Icon"
import { LANGS } from "types/shared"

const SelectDate: React.FC<ISelectDateProps> = ({
  name,
  selected,
  startDate,
  endDate,
  minDate,
  maxDate,
  onChange,
  label,
  locale = LANGS.EN,
  withBlueIcon
}) => {

  const handleChange = (date: Date) => {
    onChange(name, date)
  }



  return (
    <FormControl>
      {label && <FormLabel id={name} text={label} />}
      <Box className="datepicker-container">
        <DatePicker
          onFocus={e => e.target.blur()}
          selected={selected}
          startDate={startDate}
          endDate={endDate}
          minDate={minDate}
          maxDate={maxDate}
          onChange={handleChange}
          locale={getDateFNSLocale(locale)}
        />
        <Box className="datepicker-input-icon">
          <Icon name="calendar" iconStyles={{
            fill: withBlueIcon ? "primary" : "gray",
          }} />
        </Box>
      </Box>
    </FormControl>
  )
}

export default SelectDate
